const BASE = '/backend/api/exchanges';

export async function exchangeRequest(path, { method = 'GET', body, csrf, signal, download = false } = {}) {
  const response = await fetch(`${BASE}${path}`, {
    method, credentials: 'same-origin', cache: 'no-store', signal,
    headers: { ...(method !== 'GET' ? { 'Content-Type': 'application/json' } : {}), ...(csrf ? { 'X-Exchange-CSRF': csrf } : {}) },
    ...(body !== undefined ? { body: JSON.stringify(body) } : {})
  });
  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    throw Object.assign(new Error(payload.message || 'Le service est momentanément indisponible.'), { status: response.status });
  }
  return download ? response.blob() : response.json();
}

export function passkeyError(error) {
  if (error.name === 'NotAllowedError' || error.code === 'ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY') return 'La demande de clé d’accès a été annulée ou a expiré. Vous pouvez réessayer.';
  if (error.name === 'InvalidStateError') return 'Cette clé est déjà enregistrée. Utilisez-la pour vous connecter.';
  if (error.name === 'SecurityError') return 'La clé d’accès nécessite le domaine sécurisé configuré pour cette interface.';
  return error.message || 'La clé d’accès n’a pas pu être utilisée.';
}
